import '@/assets/scss/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import { registerDirective } from './directive'
import router from '@/router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { initWebsocket } from '@/client/webSocket'

// 配置 rem 自适应布局
function setRemUnit() {
  const designWidth = 1920 // 设计稿宽度
  const rootFontSize = 100 // 设计稿下 1rem = 100px（推荐）根节点 html font-size = 0.16rem
  const viewportWidth = window.innerWidth
  let newFontSize = (viewportWidth / designWidth) * rootFontSize
  // 设置最小和最大根字体大小，避免极端情况
  const minFontSize = 12
  const maxFontSize = 120
  // console.log(newFontSize, 'before')
  newFontSize = Math.max(minFontSize, Math.min(maxFontSize, newFontSize))
  // console.log(newFontSize, 'after')
  document.documentElement.style.fontSize = `${newFontSize}px`
}

// 初始化 rem 单位
setRemUnit()

// 监听窗口大小变化，重新计算 rem 单位
window.addEventListener('resize', setRemUnit)

const app = createApp(App)
// app.directive('focus', {
//   mounted: (el) => el.querySelector('input').focus(),
//   updated: (el) => el.querySelector('input').focus()
// })
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Route.router = router
// app.config.globalProperties.$router = router // 将 Vue Router 添加到全局属性
app.use(router).use(pinia).use(ElementPlus, {
  locale: zhCn
})
// 注册自定义指令
registerDirective(app)
// websocket客户端
initWebsocket()
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  // console.log('key', key)
  app.component(key, component)
}
//弹出内容激活时间
// app.provide<Ref<number>>('popContentActiveTime', ref(0))
app.mount('#app')
